export enum ClaimTypes {
  Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  Sid = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid',
  Surname = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
  Name = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
  NameIdentifier = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  Email = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
}
